import { render, staticRenderFns } from "./IconReplyOutline.vue?vue&type=template&id=3b8dc135"
import script from "./IconReplyOutline.vue?vue&type=script&lang=js"
export * from "./IconReplyOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports